const SettingLangConfig: Record<
  string,
  {
    setting: string;
    cancel: string;
    confirm: string;
    langLabel: string;
    tzLabel: string;
    dstLabel: string;
    dstChecked: string;
    dstUnchecked: string;
  }
> = {
  zh_CN: {
    setting: '设置',
    cancel: '取消',
    confirm: '确认',
    langLabel: '语言',
    tzLabel: '时区',
    dstLabel: '夏令时',
    dstChecked: '开启',
    dstUnchecked: '关闭',
  },
  en_US: {
    setting: 'Setting',
    cancel: 'Cancel',
    confirm: 'Yes',
    langLabel: 'Language',
    tzLabel: 'TimeZone',
    dstLabel: 'DST',
    dstChecked: 'ON',
    dstUnchecked: 'OFF',
  },
};

export default SettingLangConfig;
